import ParentCellOrFragment from '@app/src/components/Table/Cells/ParentCellOrFragment'
import { FlagOutlined } from '@mui/icons-material'
import type * as CSS from 'csstype'
import React from 'react'
import { IndicatorChip } from './IndicatorChip'

interface FlagIndicatorCellProps {
  count: number
  disableCell?: boolean
  bgcolor: CSS.Property.BackgroundColor
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const FlagIndicatorCell: React.FC<FlagIndicatorCellProps> = ({ count, disableCell, bgcolor, onClick }) => (
  <ParentCellOrFragment disableCell={disableCell} onClick={onClick}>
    <IndicatorChip count={count} icon={FlagOutlined} bgcolor={bgcolor} />
  </ParentCellOrFragment>
)

export default FlagIndicatorCell
